import React from 'react';

export default function Step3(props){
    return <div className="seehi_step">
        <a name="seehiStep3" className="seehi_anchor" />
        <h2>Keuze maken</h2>
        <p>Goede voorbereiding is het halve werk. Laat u dus goed informeren. Hieronder staan een aantal informatiebronnen die u verder helpen. Het is ook mogelijk om een adviseur in te schakelen die u hierbij helpt. Voor dit advies is ook subsidie beschikbaar. Met een maatwerkadviesrapport krijgt u inzicht in wat voor uw woning de beste mogelijkheden zijn om energie te besparen of op te wekken. Zo maakt u de juiste keuzes.</p>

        <h3>Meer informatie</h3>
        <ul className="seehi_linklist">
            <li><a href="https://www.milieucentraal.nl/energie-besparen/energiezuinig-huis/isoleren-en-besparen/" target="blank">Isoleren en besparen</a><br />
                <em>Informatie over energiebesparende maatregelen op deze pagina van Milieu Centraal.</em>
            </li>
            <li><a href="https://www.verbeterjehuis.nl" target="blank">Adviesmodule Verbeterjehuis</a><br />
                <em>Gebruik de adviesmodule Verbeterjehuis voor mogelijk energiebesparende maatregelen, ontdek wat het kost en oplevert</em>
            </li>
            <li><a href="https://www.milieucentraal.nl/energie-besparen/energiezuinig-huis/persoonlijk-energieadvies/" target="blank">Persoonlijk energieadvies</a><br />
                <em>Meer informatie over persoonlijk energieadvies van een adviseur op Milieu Centraal</em>
            </li>
            <li><a href="https://www.qbisnl.nl/zoeken/sub/Energie-advies/Maatwerkadvies%20woningen" target="blank">Maatwerkadviseur zoeken</a><br />
                <em>Een maatwerkadviseur vindt u op de pagina van QBISnl.</em>
            </li>
            {/* Website seems to be unavailable */}
            {/* <li><a href="https://www.maatwerkadviesvoorwoningen.nl" target="blank">Maatwerkadviesvoorwoningen.nl</a></li> */}
        </ul>
    </div>;
}



// WEBPACK FOOTER //
// ./src/steps/step3.js